import { useCallback } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import {
  UPDATE_ALERT_SET_GROUP_MEMBERS
} from './constants'
import { app } from '../../../common/feathers'
const userService = app.service('users')

export function updateAlertSetGroupMembers (members) {
  return {
    type: UPDATE_ALERT_SET_GROUP_MEMBERS,
    data: members
  }
}

export function useUpdateAlertSetGroupMembers () {
  const dispatch = useDispatch()
  const boundAction = useCallback((...params) => dispatch(updateAlertSetGroupMembers(...params)), [dispatch])
  const { userChecked, info } = useSelector(
    state => ({
      userChecked: state.user.userChecked,
      info: state.user.info
    }),
    shallowEqual
  );
  return { updateAlertSetGroupMembers: boundAction, userChecked, info }
}

let _tout = false
export function reducer (state, action) {
  switch (action.type) {
    case UPDATE_ALERT_SET_GROUP_MEMBERS:
      state.info = {
        ...state.info,
        alertSetGroupMembers: action.data
      }
      if (_tout) {
        clearTimeout(_tout)
      }
      _tout = setTimeout(async () => {
        // Fetch latest user data first to ensure we have fresh alertSetGroupMembers
        const freshUser = await userService.get(state.info._id)
        const userData = (freshUser && freshUser.data && Array.isArray(freshUser.data)) ? freshUser.data[0] : freshUser
        const latestMembers = userData && userData.alertSetGroupMembers ? userData.alertSetGroupMembers : []

        // Create a map of fresh members by _id for quick lookup
        const freshMembersMap = {}
        latestMembers.forEach(m => {
          if (m._id) freshMembersMap[m._id] = m
        })

        // Merge: use action.data structure but preserve verification fields from fresh data
        const mergedMembers = action.data.map(newMember => {
          const freshMember = freshMembersMap[newMember._id]
          if (freshMember) {
            return {
              ...newMember,
              // Preserve verification status from server
              emailVerified: freshMember.emailVerified !== undefined ? freshMember.emailVerified : newMember.emailVerified,
              phoneVerified: freshMember.phoneVerified !== undefined ? freshMember.phoneVerified : newMember.phoneVerified
            }
          }
          return newMember
        })

        userService.emit('patch')
        userService.patch(state.info._id, { alertSetGroupMembers: mergedMembers })
      }, 500)
      return {
        ...state
      }

    default:
      return state
  }
}
